


























import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RegistrationSetup } from '@/interfaces/registration/RegistrationSetup';
import { RegistrationData } from '@/interfaces/registration/RegistrationData';
import RegistrationErrorSummary from './RegistrationErrorSummary.vue';
import VueRecaptcha from 'vue-recaptcha';
const navigation = namespace('navigation');
const registration = namespace('registration');

@Component({
  components: {
    RegistrationErrorSummary,
    VueRecaptcha
  }
})
export default class RegistrationFooter extends Vue {
  @navigation.Getter
  public isFirstTab!: boolean;

  @navigation.Getter
  public isLastTab!: boolean;

  @navigation.State
  public navigationStopped!: boolean;

  @navigation.State
  public submitingData!: boolean;

  @navigation.Action
  public moveToNextTab!: () => void;

  @navigation.Action
  public moveToPreviousTab!: () => void;

  @navigation.Action
  public submitForm!: () => void;

  @registration.State
  public registrationSetup!: RegistrationSetup;

  @registration.State
  public registrationData!: RegistrationData;

  @registration.Action
  public saveRegistrationModel!: (payload: { data: any; model: string }) => void;

  get lastStepText (): string {
    if (screen.width <= 760) {
      switch (this.registrationSetup?.registrationType) {
        case 'AttendeeRegistration':
        case 'VolunteerRegistration':
        case 'VolunteerTeamLeaderInvite':
        case 'CompleteProfile':
          return 'Complete';
        case 'OrganizationMembership':
          return 'Continue';
        default:
          if (this.registrationData.membership?.paidMembership) {
            return 'Continue';
          }
          return 'Create';
      }
    } else {
      switch (this.registrationSetup?.registrationType) {
        case 'AttendeeRegistration':
          return 'Complete Event Registration';
        case 'VolunteerRegistration':
        case 'VolunteerTeamLeaderInvite':
          return 'Complete Registration';
        case 'OrganizationMembership':
          return 'Continue to Organization Registration';
        case 'ClaimGiftMembership':
          return 'Create Account and Claim Gift';
        case 'ClaimEcourse':
          return 'Create Account and Access Course';
        case 'CompleteProfile':
          return 'Complete Profile';
        default:
          if (this.registrationData.membership?.paidMembership) {
            return 'Continue to Payment';
          }
          return 'Create Account';
      }
    }
  }

  private setReCaptchaResponse (response: string): void {
    this.saveRegistrationModel({ data: response, model: 'reCaptchaResponse' });
    this.submitForm();
    this.resetRecaptcha();
  }

  private resetRecaptcha (): void {
    if (this.$refs.recaptcha) {
      (this.$refs.recaptcha as VueRecaptcha).reset();
    }
  }
}
